import TranslatedText from "@components/items/display/TranslatedText";
import useCurrentPlan from "@utils/hooks/useCurrentPlan";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { SubscriptionCard } from "@components/layouts/b2c/profile/subscription/SubscriptionCard";

interface SuccessProps {
  onSubmit: () => void;
  isLoading: boolean;
}

export const Success = ({ onSubmit, isLoading }: SuccessProps) => {
  const { plan } = useCurrentPlan();

  return (
    <div className="h-full">
      {!isLoading ? (
        <div className="flex h-full flex-col items-center justify-center">
          <h1 className="dark:text-dark-primary text-center text-[40px] font-bold text-primary">
            <TranslatedText text="subscription.titles.subscription completed" />
          </h1>
          <SubscriptionCard plan={plan} />
          <h2 className="mt-[35px] text-center text-[24px] font-medium text-black dark:text-white">
            <TranslatedText text="subscription.titles.thank you" />
            <TranslatedText
              className="pt-3 text-[14px] font-normal leading-5"
              text="subscription.titles.success-subscription"
            />
          </h2>
          <div className="mx-auto mt-[35px] w-[358px]">
            <div className="h-[50px] w-full">
              <ShadcnButton className="!block h-full w-full" onClick={onSubmit}>
                <TranslatedText
                  text={`subscription.buttons.${"continue"}`}
                  className="text-[20px] font-bold leading-[28px] text-white dark:text-dark_background"
                />
              </ShadcnButton>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex h-full items-center justify-center">
          <div className="h-14 w-14 animate-spin rounded-full border-[3px] border-y-black border-l-transparent border-r-black dark:border-y-white dark:border-r-white"></div>
        </div>
      )}
    </div>
  );
};
